import * as Sentry from '@sentry/browser';

export function logWarning(msg: string, args?: any) {
  if (process.env.NODE_ENV !== 'test') {
    console.warn(msg, args);
    Sentry.captureMessage(msg, Sentry.Severity.Warning);
  }
}
